import React, { useRef, useEffect } from "react";
import { Stage, Layer, Image as KonvaImage } from "react-konva";
import useImage from "use-image";

const A4_RATIO = 1.414; // A4 aspect ratio (height/width)

const BackgroundImage = () => {
  const [image] = useImage("A4.jpg");
  
  if (!image) return null;
  
  // Calculate dimensions to fit screen while maintaining A4 aspect ratio
  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;
  const padding = 20;
  
  let width = screenWidth - padding * 2;
  let height = width * A4_RATIO;
  
  // If height exceeds screen, scale down based on height
  if (height > screenHeight - padding * 2) {
    height = screenHeight - padding * 2;
    width = height / A4_RATIO;
  }
  
  return (
    <KonvaImage
      image={image}
      x={(screenWidth - width) / 2}
      y={(screenHeight - height) / 2}
      width={width}
      height={height}
    />
  );
};

const Adjustment = () => {
  const stageRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      if (stageRef.current) {
        stageRef.current.width(window.innerWidth);
        stageRef.current.height(window.innerHeight);
        stageRef.current.batchDraw();
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        overflow: "hidden",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Stage
        width={window.innerWidth}
        height={window.innerHeight}
        ref={stageRef}
      >
        <Layer>
          <BackgroundImage />
        </Layer>
      </Stage>
    </div>
  );
};

export default Adjustment;
